<template>
  <div id="tempcreate-layer">
    <light-header :back="backUrl"></light-header>
    <div class="tempcreate-content auto" v-loading="formLoading">
      <div class="tempcreate-files">
        <h3 class="tempcreate-title">
          <span>完善企业信息</span>
        </h3>
        <el-form :model="filesForm" :rules="filesRules" ref="filesForm" label-width="220px" label-position="right"
          class="files-Form">
          <div style="display: flex; flex-wrap: wrap" id="company-info-layer">
            <div style="width: 100%">
              <div style="padding: 0 0 15px; width: 90%; margin: 0 auto">
                <el-divider content-position="center">企业信息</el-divider>
              </div>
            </div>
            <!-- <el-form-item
              label="经办人类型"
              prop="applicantType"
              :rules="[
                {
                  required: true,
                  message: '请选择经办人类型',
                  trigger: 'blur',
                },
              ]"
            >
              <el-radio-group
                v-model="filesForm.applicantType"
              >
                <el-radio label="legal">法定代表人</el-radio>
                <el-radio label="agent">企业经办人</el-radio>
              </el-radio-group>
            </el-form-item> -->
            <el-form-item prop="companyName" label="企业名称" :rules="[
              {
                required: true,
                message: '请输入企业名称',
                trigger: 'blur',
              },
            ]">
              <el-input maxlength="50" v-model="filesForm.companyName" placeholder="请输入企业名称" style="width: 70%">
              </el-input>
            </el-form-item>
            <el-form-item prop="companyNo" label="企业统一社会信用代码" :rules="[
              {
                required: true,
                message: '请输入企业统一社会信用代码',
                trigger: 'blur',
              },
              { validator: checkCompanyID, trigger: 'blur' },
            ]">
              <el-input maxlength="18" v-model="filesForm.companyNo" placeholder="请输入企业统一社会信用代码" style="width: 70%">
              </el-input>
            </el-form-item>
            <el-form-item prop="legalName" label="法定代表人姓名" :rules="[
              {
                required: true,
                message: '请输入法定代表人姓名',
                trigger: 'blur',
              },
              { validator: checkChinese, trigger: 'blur' },
            ]">
              <el-input maxlength="100" v-model="filesForm.legalName" placeholder="请输入法定代表人姓名" style="width: 70%">
              </el-input>
            </el-form-item>
            <el-form-item prop="legalNo" label="法定代表人身份证号" :rules="[
              {
                required: true,
                message: '请输入法定代表人身份证号',
                trigger: 'blur',
              },
              { validator: checkID, trigger: 'blur' },
            ]">
              <el-input maxlength="18" v-model="filesForm.legalNo" placeholder="请输入法定代表人身份证号" style="width: 70%">
              </el-input>
            </el-form-item>
            <el-form-item prop="legalPhone" label="法定代表人联系电话" :rules="[
              {
                required: true,
                message: '请输入法定代表人联系电话',
                trigger: 'blur',
              },
            ]">
              <el-input maxlength="100" v-model="filesForm.legalPhone" placeholder="请输入法定代表人联系电话" style="width: 70%">
              </el-input>
            </el-form-item>
            <el-form-item prop="agentName" label="经办人姓名" :rules="[
              {
                required: true,
                message: '请输入经办人姓名',
                trigger: 'blur',
              },
              { validator: checkChinese, trigger: 'blur' },
            ]">
              <el-input maxlength="100" v-model="filesForm.agentName" placeholder="请输入经办人姓名" style="width: 70%">
              </el-input>
            </el-form-item>
            <el-form-item prop="agentNo" label="经办人身份证号" :rules="[
              {
                required: true,
                message: '请输入经办人身份证号',
                trigger: 'blur',
              },
              { validator: checkID, trigger: 'blur' },
            ]">
              <el-input maxlength="18" v-model="filesForm.agentNo" placeholder="请输入经办人身份证号" style="width: 70%">
              </el-input>
            </el-form-item>
            <!-- <el-form-item
              prop="registrationAddress"
              label="注册地"
              :rules="[
                {
                  required: true,
                  message: '请输入注册地',
                  trigger: 'blur',
                },
              ]"
            >
              <el-cascader
                :props="addressProps"
                v-model="filesForm.registrationAddress"
                :options="addressOptions"
                @change="handlerRegistrationAddressChange"
                placeholder="省/市/区"
                clearable
              ></el-cascader>
            </el-form-item>
            <el-form-item
              prop="registrationAddressDetail"
              label="注册地详细地址"
              :rules="[
                {
                  required: true,
                  message: '请输入注册地详细地址',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                maxlength="50"
                v-model="filesForm.registrationAddressDetail"
                style="width: 70%"
                placeholder="请输入注册地详细地址"
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="domicileAddress"
              label="经营地"
              :rules="[
                {
                  required: true,
                  message: '请输入经营地',
                  trigger: 'blur',
                },
              ]"
            >
              <el-cascader
                :props="addressProps"
                v-model="filesForm.domicileAddress"
                :options="addressOptions"
                @change="handleDomicileaddressChange"
                placeholder="省/市/区"
                clearable
              ></el-cascader>
            </el-form-item>
            <el-form-item
              prop="domicileAddressDetail"
              label="经营地详细地址"
              :rules="[
                {
                  required: true,
                  message: '请输入经营地详细地址',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                maxlength="50"
                v-model="filesForm.domicileAddressDetail"
                placeholder="请输入经营地详细地址"
                style="width: 70%"
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="enterpriseType"
              label="经济类型"
              :rules="[
                {
                  required: true,
                  message: '请选择经济类型',
                  trigger: 'change',
                },
              ]"
            >
              <el-select
                v-model="filesForm.enterpriseType"
                placeholder="请选择经济类型"
              >
                <el-option
                  v-for="dict in enterpriseTypeOptions"
                  :key="dict.dictValue"
                  :label="dict.dictLabel"
                  :value="dict.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="enterprisemainbusiness" label="主营业务">
              <el-input
                maxlength="50"
                v-model="filesForm.enterprisemainbusiness"
                placeholder="请输入主营业务"
                style="width: 70%"
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="enterpriseScale"
              label="企业规模"
              :rules="[
                {
                  required: true,
                  message: '请选择企业规模',
                  trigger: 'change',
                },
              ]"
            >
              <el-select
                v-model="filesForm.enterpriseScale"
                placeholder="请选择企业规模"
              >
                <el-option
                  v-for="dict in enterpriseScaleOptions"
                  :key="dict.dictValue"
                  :label="dict.dictLabel"
                  :value="dict.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              prop="establishingDate"
              label="成立日期"
              :rules="[
                {
                  required: true,
                  message: '请选择成立日期',
                  trigger: 'blur',
                },
              ]"
            >
              <el-date-picker
                v-model="filesForm.establishingDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="请选择成立日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item
              prop="industry"
              label="所属行业"
              :rules="[
                {
                  required: true,
                  message: '请输入所属行业',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                maxlength="50"
                v-model="filesForm.industry"
                placeholder="请输入所属行业"
                style="width: 70%"
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="businessStatus"
              label="营业状态"
              :rules="[
                {
                  required: true,
                  message: '请选择营业状态',
                  trigger: 'change',
                },
              ]"
            >
              <el-select
                v-model="filesForm.businessStatus"
                placeholder="请选择营业状态"
              >
                <el-option
                  v-for="dict in businessStatusOptions"
                  :key="dict.dictValue"
                  :label="dict.dictLabel"
                  :value="dict.dictValue"
                ></el-option>
              </el-select>
            </el-form-item> -->
          </div>
          <!-- <div style="display: flex; flex-wrap: wrap" id="invoice-info-layer">
            <div style="width: 100%">
              <div style="padding: 0 0 15px; width: 90%; margin: 0 auto">
                <el-divider content-position="center">开票信息</el-divider>
              </div>
            </div>

            <el-form-item
              label="企业名称（开票信息）"
              prop="invoiceName"
              :rules="[
                {
                  required: true,
                  message: '请输入企业名称（开票信息）',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                maxlength="30"
                v-model="filesForm.invoiceName"
                placeholder="请输入企业名称（开票信息）"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="纳税人识别号（开票信息）"
              prop="invoiceNo"
              :rules="[
                {
                  required: true,
                  message: '请输入纳税人识别号（开票信息）',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                maxlength="30"
                v-model="filesForm.invoiceNo"
                placeholder="请输入纳税人识别号（开票信息）"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="地址（开票信息）"
              prop="invoiceAddress"
              :rules="[
                {
                  required: true,
                  message: '请输入地址（开票信息）',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                style="width: 430px"
                maxlength="30"
                v-model="filesForm.invoiceAddress"
                placeholder="请输入地址（开票信息）"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="电话（开票信息）"
              prop="invoicePhone"
              :rules="[
                {
                  required: true,
                  message: '请输入地址（开票信息）',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                maxlength="30"
                v-model="filesForm.invoicePhone"
                placeholder="请输入地址（开票信息）"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="开户行（开票信息）"
              prop="invoiceBankName"
              :rules="[
                {
                  required: true,
                  message: '请输入开户行（开票信息）',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                maxlength="30"
                v-model="filesForm.invoiceBankName"
                placeholder="请输入开户行（开票信息）"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="银行账号（开票信息）"
              prop="invoiceBankAccount"
              :rules="[
                {
                  required: true,
                  message: '请输入银行账号（开票信息）',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                maxlength="30"
                v-model="filesForm.invoiceBankAccount"
                placeholder="请输入银行账号（开票信息）"
              ></el-input>
            </el-form-item>
          </div> -->
          <div id="auth-info-company-layer">
            <div style="width: 100%">
              <div style="padding: 0 0 15px; width: 90%; margin: 0 auto">
                <el-divider content-position="center">企业证明材料</el-divider>
              </div>
            </div>
            <el-form-item class="left-item" style="margin-top: 10px; text-align: left" label-width="300px"
              label="上传企业营业执照（不能超过5M）" :rules="[
                {
                  required: true,
                  message: '上传企业营业执照（不能超过5M）',
                  trigger: 'blur',
                },
              ]">
            </el-form-item>
            <el-form-item label-width="0" prop="licenseImgFileId" class="clearfix" :rules="[
              {
                required: true,
                message: '请上传企业营业执照',
                trigger: 'blur',
              },
            ]">
              <div class="company-upload">
                <el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false" :headers="myHeaders"
                  :data="upLoadData" :on-success="handleCompanyCardSuccess"
                  :before-upload="handleCompanyCardBeforeUpload">
                  <img v-if="filesForm.licenseImgBase64" :src="filesForm.licenseImgBase64" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  <p class="upload-text">上传企业营业执照</p>
                </el-upload>
              </div>
              <div class="upload-example">
                <p>参考示例</p>
                <div class="example-box">
                  <el-image fit="fill" :src="
                    require('../../../assets/images/auth/company/company-img1.png')
                  " alt="" :preview-src-list="[
  require('../../../assets/images/auth/company/company-img1.png'),
]" style="width: 75px"></el-image>
                </div>
              </div>
            </el-form-item>
            <el-form-item class="left-item" style="margin-top: 10px; text-align: left" label="上传法人授权书（不能超过5M）" :rules="[
              {
                required: true,
                message: '请上传法人授权书',
                trigger: 'blur',
              },
            ]">
            </el-form-item>
            <el-form-item label-width="0" prop="authFileImgFileId" class="clearfix" :rules="[
              {
                required: true,
                message: '请上传法人授权书',
                trigger: 'blur',
              },
            ]">
              <div class="company-upload">
                <el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false" :headers="myHeaders"
                  :data="upLoadData" :on-success="handleAuthFileImgSuccess"
                  :before-upload="handleHandleAuthFileImgSuccessBeforeUpload">
                  <img v-if="filesForm.authFileImgBase64" :src="filesForm.authFileImgBase64" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  <p class="upload-text">上传法人授权书</p>
                </el-upload>
              </div>
              <div class="upload-example" style="height: auto">
                <p>参考示例</p>
                <div class="example-box-wrap">
                  <div class="example-box">
                    <!-- <img
                      src="../../../assets/images/auth/company/company-auth-img.png"
                      alt=""
                      style="width: 70px"
                    /> -->
                    <el-image fit="fill" :src="
                      require('../../../assets/images/auth/company/company-auth-img.png')
                    " alt="" :preview-src-list="[
  require('../../../assets/images/auth/company/company-auth-img.png'),
]" style="width: 75px"></el-image>
                  </div>
                  <div class="auth-img-tip-wrap">
                    <div>
                      <a :href="authorizationAddress" target="_blank" style="text-decoration: underline">1.下载法人授权书模板</a>
                    </div>
                    <div>
                      2.打印后填写授权书内容并加盖公章和法定代表人印章或签名
                    </div>
                    <div>3.拍照后上传</div>
                  </div>
                </div>
              </div>
            </el-form-item>

            <el-form-item class="left-item" style="margin-top: 10px" label="企业法定代表人身份证上传" :rules="[
              {
                required: true,
                message: '企业法定代表人身份证上传',
                trigger: 'blur',
              },
            ]">
            </el-form-item>
            <el-form-item style="margin-top: 0px !important" label-width="0" prop="legalFrontImgFileId" class="clearfix"
              :rules="[
                {
                  required: true,
                  message: '请上传法定代表人身份证头像面',
                  trigger: 'blur',
                },
              ]">
              <div class="company-upload">
                <el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false" :headers="myHeaders"
                  :data="upLoadData" :on-success="handleFrontCardSuccess" :before-upload="handleFrontCardBeforeUpload">
                  <img v-if="filesForm.legalFrontImgBase64" :src="filesForm.legalFrontImgBase64" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  <p class="upload-text">上传法定代表人身份证头像面</p>
                </el-upload>
              </div>
              <div class="upload-example">
                <p>参考示例</p>
                <div class="example-box">
                  <el-image fit="fill" :src="
                    require('../../../assets/images/auth/company/company-img2.png')
                  " alt="" :preview-src-list="[
  require('../../../assets/images/auth/company/company-img2.png'),
]" style="width: 145px"></el-image>
                </div>
              </div>
            </el-form-item>
            <el-form-item label-width="0" prop="legalBackImgFileId" class="clearfix" :rules="[
              {
                required: true,
                message: '请上传法定代表人身份证国徽面',
                trigger: 'blur',
              },
            ]">
              <div class="company-upload">
                <el-upload class="avatar-uploader" :action="uploadUrl" :headers="myHeaders" :data="upLoadData"
                  :show-file-list="false" :on-success="handleBackCardSuccess" :before-upload="handleBackCardBeforeUpload">
                  <img v-if="filesForm.legalBackImgBase64" :src="filesForm.legalBackImgBase64" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  <p class="upload-text">上传法定代表人身份证国徽面</p>
                </el-upload>
              </div>
              <div class="upload-example">
                <p>参考示例</p>
                <div class="example-box">
                  <el-image fit="fill" :src="
                    require('../../../assets/images/auth/company/company-img3.png')
                  " alt="" :preview-src-list="[
  require('../../../assets/images/auth/company/company-img3.png'),
]" style="width: 145px"></el-image>
                </div>
              </div>
            </el-form-item>
            <el-form-item class="left-item" style="margin-top: 10px" label="经办人身份证上传" :rules="[
              {
                required: true,
                message: '经办人身份证上传',
                trigger: 'blur',
              },
            ]">
            </el-form-item>
            <el-form-item style="margin-top: 0px !important" label-width="0" prop="agentFrontImgFileId" class="clearfix"
              :rules="[
                {
                  required: true,
                  message: '请上传经办人身份证头像面',
                  trigger: 'blur',
                },
              ]">
              <div class="company-upload">
                <el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false" :headers="myHeaders"
                  :data="upLoadData" :on-success="handleFrontCardSuccessByAgent"
                  :before-upload="handleFrontCardBeforeUpload">
                  <img v-if="filesForm.agentFrontImgBase64" :src="filesForm.agentFrontImgBase64" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  <p class="upload-text">上传经办人身份证头像面</p>
                </el-upload>
              </div>
              <div class="upload-example">
                <p>参考示例</p>
                <div class="example-box">
                  <el-image fit="fill" :src="
                    require('../../../assets/images/auth/company/company-img2.png')
                  " alt="" :preview-src-list="[
  require('../../../assets/images/auth/company/company-img2.png'),
]" style="width: 145px"></el-image>
                </div>
              </div>
            </el-form-item>
            <el-form-item label-width="0" prop="agentBackImgFileId" class="clearfix" :rules="[
              {
                required: true,
                message: '请上传经办人身份证国徽面',
                trigger: 'blur',
              },
            ]">
              <div class="company-upload">
                <el-upload class="avatar-uploader" :action="uploadUrl" :headers="myHeaders" :data="upLoadData"
                  :show-file-list="false" :on-success="handleBackCardSuccessByAgent"
                  :before-upload="handleBackCardBeforeUpload">
                  <img v-if="filesForm.agentBackImgBase64" :src="filesForm.agentBackImgBase64" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  <p class="upload-text">上传经办人身份证国徽面</p>
                </el-upload>
              </div>
              <div class="upload-example">
                <p>参考示例</p>
                <div class="example-box">
                  <el-image fit="fill" :src="
                    require('../../../assets/images/auth/company/company-img3.png')
                  " alt="" :preview-src-list="[
  require('../../../assets/images/auth/company/company-img3.png'),
]" style="width: 145px"></el-image>
                </div>
              </div>
            </el-form-item>
          </div>
          <div style="width: 100%">
            <div style="padding: 0 0 15px; width: 90%; margin: 0 auto">
              <el-divider></el-divider>
            </div>
          </div>
          <el-form-item label-width="0" class="text-tip-item">
            <div class="text-tip-item-wrap">
              <div>
                <i class="el-icon-warning-outline" style="color: #999; font-size: 16px"></i>
              </div>
              <div>
                <p class="text-tip">1.图片未经任何软件编辑修改</p>
                <p>2.确保四边角完整，水印、文字、图片、证件号码等清晰可辨</p>
                <p>
                  3.原件照片或彩色扫描件，格式为JPG、JPEG、PNG，大小不超过2MB
                </p>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="tempcreate-users-box auto">
      <div class="sign-btns">
        <el-button type="primary" @click="handleSaveCompanyInfo" :disabled="formLoading">提 交</el-button>
      </div>
    </div>
  </div>
</template>
<script>
// import { Loading } from "element-ui";\
import { mapState } from "vuex";
import { getToken, getConsoleUrl } from "@/utils/auth";
import { contractTemplateImgApi } from "@/api/template/index";
import { getDraftInfo } from "@/api/sign/sign";
import { getComapnayAuthInfo, updateCompanyAuthInfo } from "@/api/auth/auth";
import {
  authorizationAddressPath,
  submitCompanyAuthInfo,
} from "@/api/auth/auth";
import { parseTime, downloadFile } from "@/utils/index";
import lightHeader from "@/components/lightHeader";

import { MessageBox } from 'element-ui'
import store from '@/store'

export default {
  components: {
    lightHeader,
  },
  computed: {
    ...mapState(["companyList", "currentSpace", "userInfo"]),
    isUser() {
      return this.$route.query.isuse == 1 ? true : false;
    },
    uploadData() {
      if (this.currentSpace) {
        return { companyId: this.currentSpace.companyId };
      } else {
        return { companyId: "" };
      }
    },
    backUrl() {
      if (this.$route.query.from) {
        return this.$route.query.from.replace(/\!\!/g, "?");
      } else {
        return true;
      }
    },
  },
  data() {
    return {
      authorizationAddress:
        ((process.env.NODE_ENV == "production" && GLOBAL_CONFIG && GLOBAL_CONFIG.APP_STATIC_RESOURCE_URL) ? GLOBAL_CONFIG.APP_STATIC_RESOURCE_URL : process.env.VUE_APP_STATIC_RESOURCE_URL) + authorizationAddressPath,
      formLoading: false,
      type: "",
      addressOptions: [],
      addressProps: {
        value: "code",
        label: "name",
      },
      enterpriseTypeOptions: [],
      enterpriseScaleOptions: [],
      businessStatusOptions: [],
      signId: "",
      tenantId: this.$store.state.currentSpace.tenantId,
      spaceList: this.$store.state.spaceInfoList,
      filesForm: {
        companyType: "company",
        legalBackImgFileId: "",
        legalBackImgBase64: "",
        legalFrontImgFileId: "",
        legalFrontImgBase64: "",
        licenseImgFileId: "",
        licenseImgBase64: "",
        authFileImgFileId: "",
        authFileImgBase64: "",
        agentFrontImgFileId: "",
        agentFrontImgBase64: "",
        agentBackImgFileId: "",
        agentBackImgBase64: "",
      },
      signFileInfoArray: [],

      // taskName: "",
      // signExpireTime: "",
      fileIdArray: [],

      clickSubmit: false,
      templateUploadUrl:
        ((process.env.NODE_ENV == "production" && GLOBAL_CONFIG && GLOBAL_CONFIG.APP_BASE_API) ? GLOBAL_CONFIG.APP_BASE_API : process.env.VUE_APP_BASE_API) + "api/common/v1/tool/uploadSignFile",
      templateUrl:
        ((process.env.NODE_ENV == "production" && GLOBAL_CONFIG && GLOBAL_CONFIG.APP_BASE_API) ? GLOBAL_CONFIG.APP_BASE_API : process.env.VUE_APP_BASE_API) + "contractTemplate/saveTemplate",
      myHeaders: {
        Authorization: getToken(),
      },
      // uploadData: {
      //   companyId: this.currentSpace.companyId || ''
      // },
      dialogVisible: false,
      pngList: [],
      percentage: 0,

      filesRules: {},
      contractTypes: [],
      defaultPDF: require("../../../assets/images/sign/pdf.png"),

      isEdit: false,

      isReAuth: false,

      isProgess: false,

      uploadUrl:
        ((process.env.NODE_ENV == "production" && GLOBAL_CONFIG && GLOBAL_CONFIG.APP_BASE_API) ? GLOBAL_CONFIG.APP_BASE_API : process.env.VUE_APP_BASE_API) + "api/common/v1/tool/uploadFile",
      upLoadData: {},

      checkID: (rule, value, callback) => {
        let idcard_patter =
          /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/;
        if (!idcard_patter.test(value)) {
          callback(new Error("身份证号输入有误！"));
        } else {
          callback();
        }
      },
      checkChinese: (rule, value, callback) => {
        var reg = /^[\u0391-\uFFE5]+$/;
        if (!reg.test(value)) {
          callback(new Error("只能输入中文！"));
        } else {
          callback();
        }
      },

      checkCompanyID: (rule, value, callback) => {
        var reg = /^[A-Z0-9]{18}$/;
        if (!reg.test(value)) {
          callback(
            new Error("企业统一社会信用代码由18位数字或大写英文字母组成")
          );
        } else {
          callback();
        }
      },
    };
  },
  created() {
    this.isEdit = this.$route.query.edit == "yes";
    this.isReAuth = this.$route.query.re == "yes";
    this.type = this.$route.query.type;
    if (this.isEdit) {
      this.formLoading = true;
      getComapnayAuthInfo({ userId: this.userInfo.userId }).then(res => {
        this.filesForm = res.data;
        this.formLoading = false;
      })
    }
    // getCityCode().then(({ data }) => {
    //   this.addressOptions = data.cityCode;
    // });
    // this.getDicts("cus_enterprise_type").then((response) => {
    //   this.enterpriseTypeOptions = response.data;
    // });
    // this.getDicts("cus_enterprise_scale").then((response) => {
    //   this.enterpriseScaleOptions = response.data;
    // });
    // this.getDicts("cus_business_status").then((response) => {
    //   this.businessStatusOptions = response.data;
    // });
  },
  methods: {
    handleDispatchDateRangeChange(currentField) {
      if (
        new Date(this.filesForm["dispatchstartdatetime"]) >
        new Date(this.filesForm["dispatchenddatetime"])
      ) {
        if (currentField == "1") {
          this.filesForm["dispatchstartdatetime"] = "";
        } else {
          this.filesForm["dispatchenddatetime"] = "";
        }
        this.$message({
          showClose: true,
          message: "起始时间不得大于结束时间",
          type: "warning",
        });
      }
    },
    handleContractsDateRangeChange(currentField) {
      if (
        new Date(this.filesForm["contractstartdatetime"]) >
        new Date(this.filesForm["contractenddatetime"])
      ) {
        if (currentField == "1") {
          this.filesForm["contractstartdatetime"] = "";
        } else {
          this.filesForm["contractenddatetime"] = "";
        }
        this.$message({
          showClose: true,
          message: "起始时间不得大于结束时间",
          type: "warning",
        });
      }
    },
    handleProbationDateRangeChange(currentField) {
      if (
        new Date(this.filesForm["probationstartdatetime"]) >
        new Date(this.filesForm["probationenddatetime"])
      ) {
        if (currentField == "1") {
          this.filesForm["probationstartdatetime"] = "";
        } else {
          this.filesForm["probationenddatetime"] = "";
        }
        this.$message({
          showClose: true,
          message: "起始时间不得大于结束时间",
          type: "warning",
        });
      }
    },
    treeFind(tree, func) {
      for (const data of tree) {
        if (func(data)) return data;
        if (data.children) {
          const res = this.treeFind(data.children, func);
          if (res) return res;
        }
      }
      return null;
    },
    handlerRegistrationAddressChange(data) {
      this.filesForm.registrationAddressProvince = data[0];
      this.filesForm.registrationAddressCity = data[1];
      this.filesForm.registrationAddressCounty = data[2];
      this.filesForm.registrationAddressProvincename = this.treeFind(
        this.addressOptions,
        (item) => {
          return item.code == data[0];
        }
      ).name;
      this.filesForm.registrationAddressCityname = this.treeFind(
        this.addressOptions,
        (item) => {
          return item.code == data[1];
        }
      ).name;
      this.filesForm.registrationAddressCountyname = this.treeFind(
        this.addressOptions,
        (item) => {
          return item.code == data[2];
        }
      ).name;
    },
    handleEnterprisedomicileaddressChange(data) {
      this.filesForm.enterprisedomicileaddressprovince = data[0];
      this.filesForm.enterprisedomicileaddresscity = data[1];
      this.filesForm.enterprisedomicileaddresscounty = data[2];
      this.filesForm.enterprisedomicileaddressprovincename = this.treeFind(
        this.addressOptions,
        (item) => {
          return item.code == data[0];
        }
      ).name;
      this.filesForm.enterprisedomicileaddresscityname = this.treeFind(
        this.addressOptions,
        (item) => {
          return item.code == data[1];
        }
      ).name;
      this.filesForm.enterprisedomicileaddresscountyname = this.treeFind(
        this.addressOptions,
        (item) => {
          return item.code == data[2];
        }
      ).name;
    },
    handlePersonaddressChange(data) {
      this.filesForm.personaddressprovince = data[0];
      this.filesForm.personaddresscity = data[1];
      this.filesForm.personaddresscounty = data[2];
      this.filesForm.personaddressprovincename = this.treeFind(
        this.addressOptions,
        (item) => {
          return item.code == data[0];
        }
      ).name;
      this.filesForm.personaddresscityname = this.treeFind(
        this.addressOptions,
        (item) => {
          return item.code == data[1];
        }
      ).name;
      this.filesForm.personaddresscountyname = this.treeFind(
        this.addressOptions,
        (item) => {
          return item.code == data[2];
        }
      ).name;
    },
    handleDomicileaddressChange(data) {
      this.filesForm.domicileAddressProvince = data[0];
      this.filesForm.domicileAddressCity = data[1];
      this.filesForm.domicileAddressCounty = data[2];
      this.filesForm.domicileAddressProvincename = this.treeFind(
        this.addressOptions,
        (item) => {
          return item.code == data[0];
        }
      ).name;
      this.filesForm.domicileAddressCityname = this.treeFind(
        this.addressOptions,
        (item) => {
          return item.code == data[1];
        }
      ).name;
      this.filesForm.domicileAddressCountyname = this.treeFind(
        this.addressOptions,
        (item) => {
          return item.code == data[2];
        }
      ).name;
    },

    returnIndex() {
      // this.$router.push('/')
      window.location.href = getConsoleUrl() + "/templateCenter/template";
    },
    handleFileSuccess(response, file, fileList) {
      if (response.code != 200) {
        this.$message({
          showClose: true,
          message: response.message,
          type: "warning",
        });
        // this.$refs.upload.clearFiles();
        // this.isEdit = false
        // this.fileId = "";
        // this.fileIdArray = [];
      } else {
        // this.defaultPDF =
        this.fileIdArray.push(response.data.signFileId);
        // this.filesForm.cname = file.name.substring(
        // 	0,
        // 	file.name.lastIndexOf(".")
        // );
        this.isUpload = true;

        // var uploadTimer = null;
        // var progressTimer = null;

        // uploadTimer = setInterval(() => {
        // 	this.percentage += 2;
        // 	if (this.percentage >= 99) {
        // 		this.percentage = 99;
        // 		clearInterval(uploadTimer);

        // 		progressTimer = setInterval(() => {
        // 			contractTemplateImgApi(
        // 				this.fileId || this.$route.query.templateId
        // 			)
        // 				.then(res => {
        // 					if (res.code == "0") {
        // 						this.percentage = 100;
        // 						clearInterval(progressTimer);
        // 					}
        // 				})
        // 				.catch(err => {
        // 					console.log(err);
        // 				});
        // 		}, 1000);
        // 	}
        // }, 60);
      }
    },
    handleFileError(err, file, fileList) {
      console.log(err);
      this.$message({
        showClose: true,
        message: "文件上传失败！",
        type: "warning",
      });
    },
    handleTemplateBeforeUpload(file) {
      let type = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (type != "pdf") {
        // this.$refs.upload.clearFiles();
        this.$message.warning(`请上传pdf文件！`);
        return false;
      } else {
        if (file.size > 20 * 1024 * 1024) {
          this.$message.warning(`文件大小超出20M限制，请重新上传！`);
          return false;
        } else {
        }
      }

      if (file.size > 20 * 1024 * 1024) {
        this.$message.warning(`文件大小超出20M限制，请重新上传！`);
        return false;
      } else {
      }
    },
    handleRemove(file) {
      // 缩略图模板里删除文件
      let fileList = this.$refs.upload.uploadFiles;
      let index = fileList.findIndex((fileItem) => {
        return fileItem.uid === file.uid;
      });
      fileList.splice(index, 1);
      this.fileIdArray.splice(index, 1);
      // this.$refs.upload.clearFiles();
      // this.isEdit = false;
      // this.fileId = "";
      // this.percentage = 0;
    },
    checkContractName(rule, value, callback) {
      var reg = new RegExp(
        '(?!((^(con)$)|^(con)/..*|(^(prn)$)|^(prn)/..*|(^(aux)$)|^(aux)/..*|(^(nul)$)|^(nul)/..*|(^(com)[1-9]$)|^(com)[1-9]/..*|(^(lpt)[1-9]$)|^(lpt)[1-9]/..*)|^/s+|.*/s$)(^[^/////:/*/?/"/</>/|]{1,50}$)'
      );
      if (!reg.test(value)) {
        callback(new Error('合同名不能包含下列任何字符:/:*?"<>|'));
      } else {
        callback();
      }
    },
    getContractImgsHandle() {
      return new Promise((resolve, reject) => {
        contractTemplateImgApi(this.fileId || this.$route.query.templateId)
          .then((res) => {
            console.log(res);
            if (res.code !== 200) {
              this.$message({
                showClose: true,
                message: res.message,
                type: "warning",
              });
            } else {
              resolve(res.data.pngList);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },

    handleSaveCompanyInfo() {
      // this.$router.push({
      //   path: "/sign",
      //   query: {
      //     taskId: "8b9be1eb025648b3a14a255bc7ef7be7",
      //     from: this.$route.query.from,
      //     type: this.$route.query.type,
      //   },
      // });
      // return;
      this.$refs.filesForm.validate((valid) => {
        if (valid) {
          // var reg = /^[\u0391-\uFFE5]+$/;
          // if (!this.fileIdArray.length) {
          //   this.$message({
          //     showClose: true,
          //     message: "请上传合同！",
          //     type: "warning",
          //   });
          //   return;
          // }
          // if (!this.signatoryList.length) {
          //   this.$message({
          //     showClose: true,
          //     message: "请添加签署人！",
          //     type: "warning",
          //   });
          //   return;
          // }

          this.formLoading = true;
          let handlerName = (this.isEdit && !this.isReAuth) ? updateCompanyAuthInfo : submitCompanyAuthInfo;
          // 提交保存项
          handlerName(this.filesForm)
            .then((res) => {
              this.formLoading = false;
              if (res.code !== 200) {
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: "warning",
                });
              } else {
                // this.$router.go(-1);
                this.$router.replace("/");
              }
              console.log(res);
            })
            .catch(() => {
              this.formLoading = false;
            });

          // this.getContractImgsHandle().then(data => {
          // 	if (this.signatoryList.length > 0) {
          // 		let isvalid = true;

          // 		if (isvalid) {
          // 			let signatoryList = [];
          // 			this.signatoryList.forEach(item => {
          // 				signatoryList.push({
          // 					signingBody: item.signingBody,
          // 					signSequence: item.signSequence,
          // 					account: item.account,
          // 					subjectName: item.subjectName,
          // 					agentAccount: item.agentAccount,
          // 					agentName: item.agentName
          // 				});
          // 			});

          // 			this.toPositionHandle(signatoryList);
          // 		}
          // 	} else {
          // 		this.$message({
          // 			showClose: true,
          // 			message: "请添加签署方！",
          // 			type: "warning"
          // 		});
          // 		console.log("error submit!");
          // 		return false;
          // 	}
          // });
        }
      });
    },
    handleHandleAuthFileImgSuccessBeforeUpload(file) {
      if (
        file.type == "image/png" ||
        file.type == "image/jpeg" ||
        file.type == "image/jpg"
      ) {
      } else {
        this.$message.warning(`图片类型不正确，请重新上传图片！`);
        return false;
      }
      if (file.size > 5 * 1024 * 1024) {
        this.$message.warning(`图片大小超出限制，请重新上传图片！`);
        return false;
      }
    },
    handleCompanyCardBeforeUpload(file) {
      if (
        file.type == "image/png" ||
        file.type == "image/jpeg" ||
        file.type == "image/jpg"
      ) {
      } else {
        this.$message.warning(`图片类型不正确，请重新上传图片！`);
        return false;
      }
      if (file.size > 5 * 1024 * 1024) {
        this.$message.warning(`图片大小超出限制，请重新上传图片！`);
        return false;
      }
    },
    handleFrontCardBeforeUpload(file) {
      if (
        file.type == "image/png" ||
        file.type == "image/jpeg" ||
        file.type == "image/jpg"
      ) {
      } else {
        this.$message.warning(`图片类型不正确，请重新上传图片！`);
        return false;
      }
      if (file.size > 2 * 1024 * 1024) {
        this.$message.warning(`图片大小超出限制，请重新上传图片！`);
        return false;
      }
    },
    handleBackCardBeforeUpload(file) {
      if (
        file.type == "image/png" ||
        file.type == "image/jpeg" ||
        file.type == "image/jpg"
      ) {
      } else {
        this.$message.warning(`图片类型不正确，请重新上传图片！`);
        return false;
      }
      if (file.size > 2 * 1024 * 1024) {
        this.$message.warning(`图片大小超出限制，请重新上传图片！`);
        return false;
      }
    },
    handleResponseFail(response) {
      if (response.code == -10) {
        MessageBox.confirm(
          '登录状态已过期，请重新登录',
          '系统提示',
          {
            showCancelButton: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            showClose: false,
            confirmButtonText: '重新登录',
            type: 'warning'
          }
        ).then(() => {
          store.dispatch('LogOut').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
        })
        return false;
      } else {
        return true;
      }
    },
    handleAuthFileImgSuccess(response, file, fileList) {
      if (this.handleResponseFail(response)) {
        this.filesForm.authFileImgBase64 = URL.createObjectURL(file.raw);
        this.filesForm.authFileImgFileId = response.data.fileId;
      }

    },
    handleCompanyCardSuccess(response, file, fileList) {
      if (this.handleResponseFail(response)) {
        this.filesForm.licenseImgBase64 = URL.createObjectURL(file.raw);
        this.filesForm.licenseImgFileId = response.data.fileId;
      }
    },
    handleFrontCardSuccess(response, file, fileList) {
      if (this.handleResponseFail(response)) {
        this.filesForm.legalFrontImgBase64 = URL.createObjectURL(file.raw);
        this.filesForm.legalFrontImgFileId = response.data.fileId;
      }
    },
    handleFrontCardSuccessByAgent(response, file, fileList) {
      if (this.handleResponseFail(response)) {
        this.filesForm.agentFrontImgBase64 = URL.createObjectURL(file.raw);
        this.filesForm.agentFrontImgFileId = response.data.fileId;
      }
    },
    handleBackCardSuccess(response, file, fileList) {
      if (this.handleResponseFail(response)) {
        this.filesForm.legalBackImgBase64 = URL.createObjectURL(file.raw);
        this.filesForm.legalBackImgFileId = response.data.fileId;
      }
    },
    handleBackCardSuccessByAgent(response, file, fileList) {
      if (this.handleResponseFail(response)) {
        this.filesForm.agentBackImgBase64 = URL.createObjectURL(file.raw);
        this.filesForm.agentBackImgFileId = response.data.fileId;
      }
    },
  },
};
</script>
<style>
#tempcreate-layer .el-table .cell {
  padding: 0 20px;
  font-size: 14px;
}

#tempcreate-layer .el-table tr {
  height: 72px;
}

#tempcreate-layer .el-table th>.cell {
  font-size: 14px;
}

.hide .el-upload--picture-card {
  display: none;
}

#tempcreate-layer .el-loading-spinner {
  height: 166px;
  margin-top: -43px;
}

.el-upload-list__item {
  transition: all 0.3s ease;
}

.desc-drawer .el-drawer__header {
  margin: 0;
  height: 67px;
  padding: 15px;
  border-bottom: 1px solid #eee;
}
</style>
<style lang="scss" scoped>
.tempcreate-content {
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  margin-top: 30px;

  /deep/ .el-tabs--border-card {
    border: none;
    box-shadow: none;

    .el-tabs__header {
      background: #f0f0f5;
    }

    .el-tabs__item {
      margin-right: 12px;
      background: #e5e5e5;
      border: none;

      &.is-active {
        background: #fff;
      }
    }

    .el-tabs__content {
      padding: 0;
    }
  }

  .tempcreate-files {
    background: #ffffff;
    overflow: hidden;
    padding: 27px 27px;

    .tempcreate-title {
      height: 23px;
      line-height: 23px;
      font-size: 18px;
      color: #333333;
      border-left: 3px solid #3296fa;
      text-indent: 10px;
      font-weight: 400;
      margin-bottom: 22px;
    }

    label {
      width: 98px;
      color: #666666;
      display: inline-block;
    }
  }
}

.tempcreate-users-box {
  padding: 15px 40px;
  background: #ffffff;
  margin-top: 18px;

  .add-btn {
    padding: 11px 14px;
    background: #3296fa;
    border-radius: 10px;
    font-size: 14px;
    text-align: center;
    font-weight: 400;
    color: #ffffff;
  }

  .sign-btns button.sign-button {
    padding: 12px 18px;
    background: #3296fa;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
  }
}

#tempcreate-layer {
  background: #f0f0f5;
  min-height: 100vh;
}

// .tempcreate-content {
// 	width: 1200px;
// 	margin: 30px auto;
// }

.upload-tip {
  position: relative;
  top: -120px;
  font-size: 14px;
  color: #999999;
}

.upload-tip2 {
  text-align: center;
  font-size: 14px;
  color: #d75c57;
  margin-top: 20px;
}

.upload-progress {
  width: 320px;
  margin: 10px auto 0;
}

.progress-title {
  font-size: 14px;
  color: #606266;
  float: left;
}

.progress-box {
  width: 320px;
  /* float: right; */
  margin-right: -30px;
  margin-top: 4px;
}

.files-form-box {
  width: 320px;
  margin: 26px auto 0;
}

.upload-template {
  height: 36px;
  /* background: #E85052; */
  color: #ffffff;
  margin-top: -5px;
  margin-left: 15px;
  width: 98px;
  float: left;
  overflow: hidden;
}

.sign-btns {
  width: 718px;
  margin: 20px auto 0;
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
}

.sign-btns button {
  width: 140px;
  height: 45px;
  font-size: 14px;
}

#invoice-info-layer .el-form-item /deep/ .el-input__inner,
#invoice-info-layer .el-form-item /deep/ .el-form-item__content,
#invoice-info-layer .el-form-item /deep/ .el-date-editor,
#company-info-layer .el-form-item /deep/ .el-input__inner,
#company-info-layer .el-form-item /deep/ .el-form-item__content,
#company-info-layer .el-form-item /deep/ .el-date-editor {
  width: 300px !important;
}

h4 {
  padding: 10px 0 30px;
  text-align: center;
}

.el-divider /deep/ .el-divider__text {
  color: #999;
}

.license-title {
  font-size: 18px;
  color: #333333;
  text-align: left;
}

.company-upload {
  position: relative;
  width: 148px;
  height: 158px;
  float: left;
}

.upload-text {
  position: absolute;
  left: 0;
  bottom: 10px;
  text-align: center;
  width: 100%;
  color: #999999;
  line-height: 20px;
  padding: 0 18px;
}

.upload-example {
  float: right;
  display: flex;
  width: 288px;
  justify-content: space-between;
  line-height: 148px;
  height: 144px;
}

.example-box-wrap {
  line-height: 32px;
  text-align: center;
}

.example-box {
  width: 195px;
  height: 144px;
  border: 1px solid #dcdfe6;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.upload-example p {
  color: #333333;
}

.text-tip-item-wrap {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 0px 0px 15px;
  width: 90%;
  margin: 0 auto;
  line-height: 30px;

  p {
    margin-bottom: 0 !important;
  }
}

.text-tip-item p {
  font-size: 14px;
  color: #999;
  text-indent: 12px;
  margin-bottom: -10px;
}

#auth-info-company-layer .el-form-item__label {
  font-size: 18px;
  line-height: 48px;
}

#auth-info-company-layer .submit {
  width: 363px;
  height: 50px;
  margin: 60px auto 0;
  font-size: 18px;
  margin-bottom: 96px;
}

#auth-info-company-layer /deep/ .avatar-uploader .el-upload {
  border: 1px dashed #dcdfe6;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

#auth-info-company-layer /deep/ .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

#auth-info-company-layer /deep/ .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}

#auth-info-company-layer /deep/ .avatar {
  width: 148px;
  height: 148px;
  display: block;
  position: relative;
  z-index: 3;
}

#auth-info-company-layer .el-form-item {
  width: 55%;
  margin: 0 auto 20px;
}

#auth-info-company-layer .el-form-item /deep/ .el-form-item__label {
  width: 100% !important;
  text-align: center;
}

.auth-img-tip-wrap {
  line-height: 22px;
  text-align: left;
  width: 195px;
  word-break: break-all;
}

.upload-example /deep/ .el-image__inner {
  vertical-align: middle;
}
</style>